module.exports = __webpack_public_path__ + "static/img/empty.9501eb50.png";